export default __webpack_public_path__ + "static/media/deployment.f451c69f.png";